import {
  EVENT_WHEEL,
  EVENT_WHEEL_END,
  EVENT_WHEEL_START,
  EVENT_ZOOM,
  EVENT_ZOOMED,
} from './cropperjs/src/js/constants';
import {
  addListener,
  dispatchEvent,
  getOffset,
  getPointersCenter,
  isNumber,
  isPlainObject,
  removeListener,
} from './cropperjs/src/js/utilities';
import CustomPrint from './custom-print';

let $wheelStartID = null,
    customWheeling = false;

export const CustomCropper = {
  ...CustomPrint,

  wheel(event) {
    const ratio = Number(this.options.wheelZoomRatio) || 0.1;
    let delta = 1;

    if (this.disabled) {
      return;
    }
    
    event.preventDefault();

    // OVERRIDE REASON
    // custom start wheeling
    if (false === customWheeling) {
      customWheeling = true;
      dispatchEvent(this.element, EVENT_WHEEL_START, {});
    } 
    // else {
      clearTimeout($wheelStartID);
      $wheelStartID = setTimeout(() => {
        customWheeling = false;
        dispatchEvent(this.element, EVENT_WHEEL_END, {});
      }, 250);
    // }

    // Limit wheel speed to prevent zoom too fast (#21)
    if (this.wheeling) {
      return;
    }

    this.wheeling = true;

    setTimeout(() => {
      this.wheeling = false;
    }, 50);

    if (event.deltaY) {
      delta = event.deltaY > 0 ? 1 : -1;
    } else if (event.wheelDelta) {
      delta = -event.wheelDelta / 120;
    } else if (event.detail) {
      delta = event.detail > 0 ? 1 : -1;
    }
    
    this.zoom(-delta * ratio, event);
  },

  /**
   * Zoom the canvas with a relative ratio
   * @param {number} ratio - The target ratio.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoom(ratio, _originalEvent) {
    const { canvasData } = this;

    ratio = Number(ratio);

    if (ratio < 0) {
      ratio = 1 / (1 - ratio);
    } else {
      ratio = 1 + ratio;
    }

    dispatchEvent(this.element, EVENT_ZOOM, {});
    // if (globalHandler) {
    //   let minRatio = globalHandler.getMinZoomRatio();
    //   let deltaRatio = (canvasData.width * ratio) / canvasData.naturalWidth;
    //   ratio = Math.max(minRatio, deltaRatio);
    //   return this.zoomTo(ratio, null, _originalEvent);
    // } 

    return this.zoomTo((canvasData.width * ratio) / canvasData.naturalWidth, null, _originalEvent);
  },

  /**
   * Zoom the canvas to an absolute ratio
   * @param {number} ratio - The target ratio.
   * @param {Object} pivot - The zoom pivot point coordinate.
   * @param {Event} _originalEvent - The original event if any.
   * @returns {Cropper} this
   */
  zoomTo(ratio, pivot, _originalEvent) {
    const { options, canvasData } = this;
    const {
      width,
      height,
      naturalWidth,
      naturalHeight,
    } = canvasData;

    ratio = Number(ratio);

    if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
      let newWidth = naturalWidth * ratio;
      let newHeight = naturalHeight * ratio;

      if (dispatchEvent(this.element, EVENT_ZOOM, {
        ratio,
        oldRatio: width / naturalWidth,
        originalEvent: _originalEvent,
      }) === false) {
        return this;
      }
      
      if (_originalEvent) {
        const { pointers } = this;
        const offset = getOffset(this.cropper);
        const center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
          pageX: _originalEvent.pageX,
          pageY: _originalEvent.pageY,
        };
        
        // Zoom from the triggering point of the event
        canvasData.left -= (newWidth - width) * (
          ((center.pageX - offset.left) - canvasData.left) / width
        );
        canvasData.top -= (newHeight - height) * (
          ((center.pageY - offset.top) - canvasData.top) / height
        );
      } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
        canvasData.left -= (newWidth - width) * (
          (pivot.x - canvasData.left) / width
        );
        canvasData.top -= (newHeight - height) * (
          (pivot.y - canvasData.top) / height
        );
      } else {
        // Zoom from the center of the canvas
        canvasData.left -= (newWidth - width) / 2;
        canvasData.top -= (newHeight - height) / 2;
      }

      canvasData.width = newWidth;
      canvasData.height = newHeight;

      dispatchEvent(this.element, EVENT_ZOOMED, {
        ratio,
        oldRatio: width / naturalWidth,
        originalEvent: _originalEvent,
      });

      this.renderCanvas(true);
    }

    return this;
  },

  setZoomOnWheel(zoomOnWheel) {
    const { cropper, options } = this;
    options.zoomOnWheel = zoomOnWheel;
    if (zoomOnWheel) {
      return addListener(cropper, EVENT_WHEEL, (this.onWheel = this.wheel.bind(this)), {
        passive: false,
        capture: true,
      });
    }
    return removeListener(cropper, EVENT_WHEEL, this.onWheel, {
      passive: false,
      capture: true,
    });
  }
};